import { useCallback, useEffect, useState } from "react";

import { Alert, AlertColor, Button, Collapse, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export type AlertMessageProps = {
  message: string;
  show: boolean;
  onClose?: () => void;
  isPermanent?: boolean;
  hasAction?: boolean;
  severity?: AlertColor;
  actionMessage?: string;
};

export const AlertMessage = ({
  show,
  message,
  onClose,
  isPermanent = false,
  hasAction = false,
  severity = "success",
  actionMessage,
}: AlertMessageProps) => {
  const [display, setDisplay] = useState(show);

  const handleClose = useCallback(() => {
    onClose?.();
    setDisplay(false);
  }, [onClose]);

  useEffect(() => {
    if (isPermanent) {
      return;
    }

    const timeId = setTimeout(() => {
      handleClose();
    }, 2000);

    return () => {
      clearTimeout(timeId);
    };
  }, [handleClose, isPermanent, onClose]);

  return (
    <Collapse in={display}>
      <Alert
        severity={severity}
        sx={{ mt: "20px", whiteSpace: "pre" }}
        action={
          hasAction &&
          (actionMessage ? (
            <Button color="inherit" size="small" onClick={handleClose}>
              {actionMessage}
            </Button>
          ) : (
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          ))
        }
      >
        {message}
      </Alert>
    </Collapse>
  );
};
